/* =============================================================
   BELLATERRA MX — REBUILD PDP v2
   JavaScript consolidado
   No requiere jQuery. Vanilla JS, ES5+ compatible.
   ============================================================= */

(function() {
  'use strict';

  /* =============================================================
     1. ESTIMADOR DE ENTREGA DINÁMICO
     Calcula 3-5 días hábiles desde hoy, saltando fines de semana
     ============================================================= */

  function initDeliveryEstimator() {
    var meses = ['enero','febrero','marzo','abril','mayo','junio',
                 'julio','agosto','septiembre','octubre','noviembre','diciembre'];

    function sumarDiasHabiles(fecha, dias) {
      var resultado = new Date(fecha);
      var agregados = 0;
      while (agregados < dias) {
        resultado.setDate(resultado.getDate() + 1);
        var dow = resultado.getDay();
        if (dow !== 0 && dow !== 6) agregados++;
      }
      return resultado;
    }

    function formatear(fecha) {
      return fecha.getDate() + ' de ' + meses[fecha.getMonth()];
    }

    var hoy = new Date();
    var fechaMin = formatear(sumarDiasHabiles(hoy, 3));
    var fechaMax = formatear(sumarDiasHabiles(hoy, 5));

    document.querySelectorAll('.bt-trust__fecha-min').forEach(function(el) {
      el.textContent = fechaMin;
    });
    document.querySelectorAll('.bt-trust__fecha-max').forEach(function(el) {
      el.textContent = fechaMax;
    });
  }

  /* =============================================================
     2. STICKY CTA MOBILE
     Aparece cuando el botón principal de carrito sale del viewport
     ============================================================= */

  function initStickyCta() {
    var stickyEl = document.getElementById('bt-sticky-cta');
    if (!stickyEl) return;

    // Detectar el botón principal de carrito en theme Impulse
    var mainCta = document.querySelector('[name="add"], .product-form__cart-submit, [data-add-to-cart]');
    if (!mainCta) return;

    var ticking = false;

    function checkVisibility() {
      var rect = mainCta.getBoundingClientRect();
      var isOutOfView = rect.bottom < 0 || rect.top > window.innerHeight;
      if (isOutOfView) {
        stickyEl.classList.add('is-visible');
        stickyEl.setAttribute('aria-hidden', 'false');
      } else {
        stickyEl.classList.remove('is-visible');
        stickyEl.setAttribute('aria-hidden', 'true');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(checkVisibility);
        ticking = true;
      }
    }, { passive: true });

    // Click del botón sticky → click en CTA principal
    var stickyBtn = document.getElementById('bt-sticky-cta-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        // Scroll suave al producto y dispara click en main CTA
        var productForm = document.querySelector('.product-single, .product-form, [data-product-form]');
        if (productForm) {
          productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function() {
            mainCta.click();
          }, 600);
        } else {
          mainCta.click();
        }
      });
    }

    checkVisibility();
  }

  /* =============================================================
     3. BUNDLE BUILDER
     Calcula descuento dinámico, agrega al carrito vía Shopify AJAX
     ============================================================= */

  function initBundleBuilder() {
    var bundleEl = document.querySelector('.bt-bundle');
    if (!bundleEl) return;

    var checkboxes = bundleEl.querySelectorAll('[data-bundle-check]');
    var ctaBtn = document.getElementById('bt-bundle-cta');
    var ctaText = document.getElementById('bt-bundle-cta-text');
    var subtotalEl = document.getElementById('bt-bundle-subtotal');
    var discountLineEl = document.getElementById('bt-bundle-discount-line');
    var discountEl = document.getElementById('bt-bundle-discount');
    var totalEl = document.getElementById('bt-bundle-total');
    var progressFill = document.getElementById('bt-bundle-progress');
    var steps = bundleEl.querySelectorAll('.bt-bundle__discount-step');

    if (!ctaBtn || !ctaText || !subtotalEl || !discountLineEl || !discountEl || !totalEl || !progressFill) return;

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var formatted = '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return formatted + ' MXN';
    }

    function getSelected() {
      var selected = [];
      checkboxes.forEach(function(cb) {
        if (cb.checked && !cb.disabled) {
          var label = cb.closest('.bt-bundle__product');
          selected.push({
            variantId: cb.value,
            price: parseInt(label.dataset.productPrice, 10) || 0
          });
        }
      });
      return selected;
    }

    function syncProductClasses() {
      checkboxes.forEach(function(cb) {
        var label = cb.closest('.bt-bundle__product');
        if (!label) return;

        if (cb.checked) {
          label.classList.add('is-checked');
        } else {
          label.classList.remove('is-checked');
        }

        if (cb.disabled) {
          label.classList.add('is-disabled');
        } else {
          label.classList.remove('is-disabled');
        }
      });
    }

    function getDiscountPercent(count) {
      if (count >= 4) return 25;
      if (count === 3) return 20;
      if (count === 2) return 15;
      return 0;
    }

    function updateUI() {
      syncProductClasses();

      var selected = getSelected();
      var count = selected.length;
      var subtotal = selected.reduce(function(sum, p) { return sum + p.price; }, 0);
      var discountPct = getDiscountPercent(count);
      var discountAmount = Math.round(subtotal * discountPct / 100);
      var total = subtotal - discountAmount;

      subtotalEl.textContent = formatMoney(subtotal);

      if (discountAmount > 0) {
        discountLineEl.hidden = false;
        discountEl.textContent = '-' + formatMoney(discountAmount) + ' (' + discountPct + '%)';
      } else {
        discountLineEl.hidden = true;
      }

      totalEl.textContent = formatMoney(total);

      // Progress bar
      var progressMap = { 0: 0, 1: 0, 2: 50, 3: 75, 4: 100 };
      var progress = progressMap[Math.min(count, 4)] || 100;
      progressFill.style.width = progress + '%';

      // Steps
      steps.forEach(function(step) {
        var stepCount = parseInt(step.dataset.step, 10);
        if (count >= stepCount) {
          step.classList.add('is-active');
        } else {
          step.classList.remove('is-active');
        }
      });

      // CTA
      if (count < 2) {
        ctaBtn.disabled = true;
        ctaText.textContent = 'Selecciona al menos 2 piezas';
      } else {
        ctaBtn.disabled = false;
        ctaText.textContent = 'Agregar set al carrito · ' + formatMoney(total);
      }
    }

    checkboxes.forEach(function(cb) {
      cb.addEventListener('change', updateUI);
    });

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function() {
        var selected = getSelected();
        if (selected.length < 2) return;

        ctaBtn.disabled = true;
        ctaText.textContent = 'Agregando...';

        var items = selected.map(function(p) {
          return { id: parseInt(p.variantId, 10), quantity: 1 };
        });

        // Agregar al carrito vía Shopify AJAX API
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          // Aplicar discount code automático según cantidad
          var count = selected.length;
          var code = '';
          if (count === 2) code = 'BUNDLE2';
          else if (count === 3) code = 'BUNDLE3';
          else if (count >= 4) code = 'BUNDLE4';

          if (code) {
            // Redirige al cart con el discount code aplicado
            window.location.href = '/discount/' + code + '?redirect=/cart';
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function() {
          ctaBtn.disabled = false;
          ctaText.textContent = 'Error. Intenta de nuevo.';
          setTimeout(updateUI, 2500);
        });
      });
    }

    updateUI();
  }

  /* =============================================================
     INIT
     ============================================================= */

  function init() {
    initDeliveryEstimator();
    initStickyCta();
    initBundleBuilder();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
